import { createStore } from '@xstate/store-react';

type PageStoreContext = {
  id?: string;
  hideSidebar?: boolean;
  page?: string;
  menuItemOpen?: string;
};

export const pageStore = createStore({
  context: {
    page: '',
    id: '',
  } as PageStoreContext,
  on: {
    updatePage: (
      context,
      page: {
        id?: string;
        hideSidebar?: boolean;
        page?: string;
        menuItemOpen?: string;
      },
    ) => ({ ...context, ...page }),
  },
});
